import { Language } from '@breathelife/types';

export const seedApplication = {
  lang: Language.en,
  selectedAddons: [],
  answers: {},
};
